<template>
    <div class="board-register-banner">
        <v-container>
            <div class="register-content text-center white--text">
                <h2 class="register-title mb-6">สมัครสมาชิกตอนนี้ ใช้งานได้ทันที!</h2>
                <p class="register-subtitle mb-6">
                    สมัครสมาชิกเพื่อรับสิทธิประโยชน์มากมายในการใช้งานระบบ<br />
                    รวมไปถึงการอุดหนุนสินค้าและสะดวกสบายยิ่งขึ้น
                </p>
                <v-btn color="white" light height="48" class="px-8 font-weight-bold register-btn" elevation="0"
                    @click="goRegister">
                    สมัครสมาชิก
                </v-btn>
            </div>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "BoardRegister",
    methods: {
        goRegister() {
            this.$router.push({ name: 'register' });
        }
    }
};
</script>

<style scoped>
.board-register-banner {
    padding: 60px 0;
    max-width: 1440px;
    margin: 0 auto;
}

.register-content {
    background-color: #F4811F;
    padding: 60px;
}

.register-title {
    font-size: 42px;
    font-weight: 700;
}

.register-subtitle {
    font-size: 16px;
    font-weight: 400;
    opacity: 0.9;
    line-height: 1.5;
}

.register-btn {
    font-size: 16px;
}

@media (max-width: 600px) {
    .board-register-banner {
        padding: 32px 0;
    }

    .register-content {
        padding: 36px 20px;
    }

    .register-title {
        font-size: 24px;
        line-height: 1.3;
        margin-bottom: 16px !important;
    }

    .register-subtitle {
        font-size: 14px;
        margin-bottom: 20px !important;
    }

    .register-subtitle br {
        display: none;
    }
}
</style>
